// extracted by mini-css-extract-plugin
module.exports = {"root":"NotificationBadge_root__2IRJZ"};